module.exports = __webpack_public_path__ + "static/media/photo.0be85d56.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/about/assets/photo.jpeg
// module id = 63
// module chunks = 0